<template>
  <div>
    <template v-if="$store.state.botProfile.data && $store.state.botProfile.data.length > 0">
      <div class="text-xs-right">
        <v-btn
          color="primary"
          outline
          :disabled="$store.state.botProfile.total >= 10"
          @click="handleEditAvatar(undefined)"
          >{{ $t('Add') }}</v-btn
        >
      </div>
      <template v-for="botProfile in $store.state.botProfile.data">
        <v-card :key="botProfile.id" class="my-2">
          <v-layout justify-center align-center>
            <v-flex class="pa-2" shrink>
              <v-avatar :key="botProfile.id" size="40">
                <img :src="botProfile.profile_pic" />
              </v-avatar>
            </v-flex>
            <v-flex>
              {{ botProfile.name }}
            </v-flex>
            <v-flex shrink>
              <v-btn icon small outline>
                <v-icon small @click="handleDeleteAvatar">delete</v-icon>
              </v-btn>
              <v-btn icon small outline>
                <v-icon small @click="handleEditAvatar(botProfile)">edit</v-icon>
              </v-btn>
              <v-btn outline @click="$emit('onSelectAvatar', botProfile)">
                {{ $t('Select') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </template>
    </template>
    <template v-else>
      <div
        style="text-align: center; cursor: pointer"
        class="pa-2 z-border-red"
        @click="handleEditAvatar(undefined)"
      >
        <v-icon small class="mr-2">add</v-icon>
        {{ $t('add_bot_profile') }}
      </div>
    </template>

    <DialogManageBotProfileVue v-model="showDialog" :profile="currentProfile" />
  </div>
</template>

<script>
import DialogManageBotProfileVue from './DialogManageBotProfile.vue'
import botProfileApi from '@/api/bot-profile/bot-profile.js'
import { mapGetters } from 'vuex'
import { handleApiError } from '@/api/util'

export default {
  components: {
    DialogManageBotProfileVue
  },
  data() {
    return {
      showDialog: false,
      currentProfile: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    handleEditAvatar(botProfile) {
      this.currentProfile = botProfile
      this.showDialog = true
    },
    async handleDeleteAvatar() {
      try {
        const result = await this.$swal.fire({
          title: this.$t('Do you want to delete this?'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        if (result.value) {
          const response = await botProfileApi.deleteBotProfile({
            data: {
              id: this.currentProfile.id,
              page_id: this.selectedBot.page_id
            }
          })
          if (response.status === 200 || response.status === 204) {
            this.$store.dispatch('loadBotProfile')
            this.$swal({
              title: this.$t('Save successful'),
              type: 'success',
              confirmButtonText: this.$t('Confirm'),
              reverseButtons: true
            })
          }
        }
      } catch (error) {
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/BotProfile/BotProfile.vue